import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import {
  AttendeeNote,
  CreateAttendeeNotePayload,
  UpdateAttendeeNotePayload,
} from "../../types/Types";

export const useSaveAttendeeNote = (
  options?: UseMutationOptions<
    AttendeeNote,
    unknown,
    CreateAttendeeNotePayload | UpdateAttendeeNotePayload,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: CreateAttendeeNotePayload | UpdateAttendeeNotePayload) => {
      if ("id" in data && data.id) {
        return axiosInstance
          .put<AttendeeNote>(getAPIURL(`/AttendeeNote/${data.id}`), {
            noteText: data.noteText,
          })
          .then((res) => res.data);
      }

      const create = data as CreateAttendeeNotePayload;
      return axiosInstance
        .post<AttendeeNote>(getAPIURL("/AttendeeNote"), {
          eventId: create.eventId,
          attendeeObjectId: create.attendeeObjectId,
          noteText: create.noteText,
        })
        .then((res) => res.data);
    },
  });
};
